import React, { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { strings } from 'investira.sdk';
import { PaginationTemplate } from '../../components/templates';
import services from '../../services';
import IndicadoresItem from './_components/IndicadoresItem';
import IndicadoresItemSkeleton from './_components/IndicadoresItemSkeleton';
import IndicadoresTerms from './_components/IndicadoresTerms';
import { resolveIndicadoresSort } from './_shared/indicadoresSortOptions';
import { getIndicadoresTipoRouteContext } from './_shared/indicadoresTipoRoute';

/** Lista somente os indicadores pertencentes ao tipo definido pela rota. */
const IndicadoresTipo = memo(() => {
  const xLocation = useLocation();
  const { route: xRoute, tipo: xTipo } = getIndicadoresTipoRouteContext(xLocation.pathname);
  const xSearch = strings.querystringToObject(xLocation.search) || {};

  if (!xTipo) {
    return <Navigate replace to="/indicadores" />;
  }

  /** Impõe o tipo da rota antes de consultar o serviço de pesquisa. */
  function pvList(pParams, pResolve, pReject, pFinally) {
    const xParams = { ...pParams };

    delete xParams.indicador_tipo_id;

    return services.pesquisas.indicador(
      { ...xParams, indicador_tipo_id: xTipo.id },
      pResolve,
      pReject,
      pFinally
    );
  }

  const xSort = resolveIndicadoresSort(xSearch.sort, Boolean(xSearch.pesquisa));

  return (
    <PaginationTemplate
      id="indicadores"
      title={xTipo.descricao}
      description={xTipo.metadata.description}
      dataRead={pvList}
      dataReadParams={{ sort: xSort }}
      termsComponent={IndicadoresTerms}
      listItem={IndicadoresItem}
      listItemSkeleton={IndicadoresItemSkeleton}
      listItemKey="indicador_id"
      listItemProps={{ pathnameBase: '/indicadores' }}
      listSx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(1, minmax(0, 1fr))',
          sm: 'repeat(2, minmax(0, 1fr))',
          md: 'repeat(3, minmax(0, 1fr))',
          lg: 'repeat(4, minmax(0, 1fr))',
          xl: 'repeat(5, minmax(0, 1fr))'
        },
        gap: 2
      }}
      pageSize={25}
      match={`indicadores/${xRoute}/*`}
      maxWidth="xl"
    />
  );
});

IndicadoresTipo.displayName = 'IndicadoresTipo';

export default IndicadoresTipo;
